import React, { Component } from "react"
import SettingsTopNav from "./settings_top_nav"
import ProfileSettings from "./profile_settings"
import BillingSettings from "./billing_settings"
import { ConnectedApps } from "./connected_apps/connected_apps"

class SettingsDashboard extends Component {
    render() {
        const {
            setSelectedSettingsTab,
            selectedSettingsTab,
            selectedTeamInvites,
            customer,
            paymentModalOpen,
            isLoading,
            profile,
            changePassword,
            updateUserName,
            setPaymentModalOpen,
            handleCancelPlan,
            handleChangePaymentMethod,
            ui,
            accounts,
            updateAccountName,
            updateUserTimezone,
            updateNotificationPreferences,
            oAuthTokens,
            googleCalendarConfigs,
            teams,
            tags,
            zoomConfigs,
        } = this.props
        return (
            <div className="settings-dashboard">
                <SettingsTopNav
                    setSelectedSettingsTab={setSelectedSettingsTab}
                    selectedSettingsTab={selectedSettingsTab}
                />
                {selectedSettingsTab === "billing" && (
                    <BillingSettings
                        selectedTeamInvites={selectedTeamInvites}
                        customer={customer}
                        paymentModalOpen={paymentModalOpen}
                        isLoading={isLoading}
                        setPaymentModalOpen={setPaymentModalOpen}
                        handleCancelPlan={handleCancelPlan}
                        handleChangePaymentMethod={handleChangePaymentMethod}
                        accounts={accounts}
                        updateAccountName={updateAccountName}
                        profile={profile}
                    />
                )}
                {selectedSettingsTab === "profile" && (
                    <ProfileSettings
                        profile={profile}
                        changePassword={changePassword}
                        updateUserName={updateUserName}
                        updateUserTimezone={updateUserTimezone}
                        updateNotificationPreferences={updateNotificationPreferences}
                        ui={ui}
                        scrollToNotificationPreferences={ui.notificationPreferences}
                    />
                )}
                {selectedSettingsTab === "connected apps" && (
                    <ConnectedApps
                        oAuthTokens={oAuthTokens}
                        googleCalendarConfigs={googleCalendarConfigs}
                        zoomConfigs={zoomConfigs}
                        teams={teams}
                        profile={profile}
                        tags={tags}
                    />
                )}
            </div>
        )
    }
}

export default SettingsDashboard



// WEBPACK FOOTER //
// ./src/components/settings_dashboard.jsx